(() => {
  const boot = window.ShejtanoBoot, root = document.documentElement;
  if (!boot || !['loading', 'background'].includes(root.dataset.shejBoot)) return;
  const host = document.querySelector('#shejtano-background');
  const targets = document.querySelectorAll('body > .shopify-section-group-header-group, body > #MainContent, body > .shopify-section-group-footer-group');
  for (const node of targets) if (!node.inert) { node.inert = true; node.setAttribute('data-shej-boot-inert', ''); }
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const controller = new AbortController(), options = {signal: controller.signal};
  let background = false, viewer = false, timer = 0;
  function check() {
    if (root.dataset.shejBoot === 'reveal' || !root.hasAttribute('data-shej-boot')) return;
    if (!background || !viewer) return;
    clearTimeout(timer);
    const wait = reduced ? 0 : Math.max(0, 450 - (performance.now() - boot.started));
    timer = setTimeout(() => boot.release(), wait);
  }
  function backgroundReady() {
    if (background) return;
    background = true;
    if (root.dataset.shejBoot === 'loading') root.dataset.shejBoot = 'background';
    check();
  }
  function viewerReady() { viewer = true; check(); }
  document.addEventListener('shejtano:background-ready', backgroundReady, options);
  document.addEventListener('shejtano:viewer-painted', viewerReady, options);
  document.addEventListener('shejtano:viewer-failed', viewerReady, options);
  document.addEventListener('shejtano:boot-reveal', () => { controller.abort(); clearTimeout(timer); }, {once: true});
  if (!host || ['ready', 'fallback'].includes(host.dataset.renderState)) backgroundReady();
  if (document.body.dataset.sclPainted === 'true' || document.body.dataset.sclFailed === 'true') viewerReady();
})();
